export function addCurrent(calledorganizationchecklist) {
  return {
      type: 'ADD_CURRENT',
      calledorganizationchecklist,
  }
}